import Grid from "@mui/material/Grid";
import { Fragment } from "react";

import { Span } from "../Typography";
import { FlexBetween } from "../flex-box";
import Pagination from "./pagination";
import ProductItemVertical from "src/lib/components/product-item/vertical";
import { ProductCard9 } from "../product-cards/product-card-9"; // CUSTOM DATA MODEL
import Box from "@mui/material/Box";
import ResultNotFound from "src/lib/components/collection-section/default/result-not-found";

// ========================================================
const ProductResultList = ({
  products,
  viewMode,
  featuredOption,
  bgImg,
  pagingText,
  pagingProps,
}) => {
  return !pagingProps?.count ? (
    <ResultNotFound />
  ) : (
    <Fragment>
      <Box display={viewMode === "grid" ? "block" : "none"}>
        <Grid container spacing={2}>
          {products.map((product) => (
            <Grid item lg={4} sm={4} xs={6} key={product.id}>
              <ProductItemVertical {...product} featuredOption={featuredOption} />
            </Grid>
          ))}
        </Grid>
      </Box>

      <Box display={viewMode === "list" ? "block" : "none"}>
        {products.map((item) => (
          <ProductCard9 key={item.id} product={{ ...item, bgImg }} />
        ))}
      </Box>

      {!!pagingProps?.count && (
        <FlexBetween flexWrap="wrap" mt={4}>
          <Span color="grey.600">{pagingText}</Span>
          <Pagination {...pagingProps} />
        </FlexBetween>
      )}
    </Fragment>
  );
};

export default ProductResultList;
